/**
 * innerHTML property for SVGElement
 * Copyright(c) 2010, Jeff Schiller
 *
 * Licensed under the Apache License, Version 2
 *
 * Minor modifications by Chris Price to only polyfill when required.
 */
(function (SVGElement) {
	if (!SVGElement || 'innerHTML' in SVGElement.prototype) {
		return;
	}
	var serializeXML = function (node, output) {
		var nodeType = node.nodeType;
		if (nodeType == 3) { // TEXT nodes.
			// Replace special XML characters with their entities.
			output.push(node.textContent.replace(/&/, '&amp;').replace(/</, '&lt;').replace('>', '&gt;'));
		} else if (nodeType == 1) { // ELEMENT nodes.
			// Serialize Element nodes.
			output.push('<', node.tagName);
			if (node.hasAttributes()) {
				var attrMap = node.attributes;
				for (var i = 0, len = attrMap.length; i < len; ++i) {
					var attrNode = attrMap.item(i);
					output.push(' ', attrNode.name, '=\'', attrNode.value, '\'');
				}
			}
			if (node.hasChildNodes()) {
				output.push('>');
				var childNodes = node.childNodes;
				for (var i = 0, len = childNodes.length; i < len; ++i) {
					serializeXML(childNodes.item(i), output);
				}
				output.push('</', node.tagName, '>');
			} else {
				output.push('/>');
			}
		} else if (nodeType == 8) {
			// TODO(codedread): Replace special characters with XML entities?
			output.push('<!--', node.nodeValue, '-->');
		} else {
			// TODO: Handle CDATA nodes.
			// TODO: Handle ENTITY nodes.
			// TODO: Handle DOCUMENT nodes.
			throw 'Error serializing XML. Unhandled node of type: ' + nodeType;
		}
	};
	// The innerHTML DOM property for SVGElement.
	Object.defineProperty(SVGElement.prototype, 'innerHTML', {
		get: function () {
			var output = [];
			var childNode = this.firstChild;
			while (childNode) {
				serializeXML(childNode, output);
				childNode = childNode.nextSibling;
			}
			return output.join('');
		},
		set: function (markupText) {
			// Wipe out the current contents of the element.
			while (this.firstChild) {
				this.removeChild(this.firstChild);
			}

			try {
				// Parse the markup into valid nodes.
				var dXML = new DOMParser();
				dXML.async = false;
				// Wrap the markup into a SVG node to ensure parsing works.
				sXML = '<svg xmlns=\'http://www.w3.org/2000/svg\'>' + markupText + '</svg>';
				var svgDocElement = dXML.parseFromString(sXML, 'text/xml').documentElement;

				// Now take each node, import it and append to this element.
				var childNode = svgDocElement.firstChild;
				while (childNode) {
					this.appendChild(this.ownerDocument.importNode(childNode, true));
					childNode = childNode.nextSibling;
				}
			} catch (e) {
				throw new Error('Error parsing XML string');
			}
		}
	});
}((1, eval)('this').SVGElement));
$(window).on('svgRendered', (event, $elem) => {
	if ($elem.attr('id') === 'production_svg') {
		$('.production__svg').removeClass('preloader');

		$(document).on('touchstart', function (event) {
			if (!$(event.target).closest('.production__tooltip, .chain-elem').length && $('.chain-elem.active').length) {
				hideTooltip();
			}
		});

		function hideTooltip() {
			const $prev = $('.production__tooltip.js-prev');
			const $active = $('.production__tooltip.js-active');
			const $activeChain = $('.chain-elem.active');
			const $activeStage = $('.stage.active');

			$prev
				.removeClass('js-prev')
				.addClass('js-active');
			$active
				.velocity('stop', true)
				.velocity('fadeOut', 200)
				.addClass('js-prev')
				.removeClass('js-active');
			$activeChain.removeClass('active');
			$activeStage.removeClass('active');
		}

		$('.chain-elem')
			.on('mouseover', function () {
				const $this = $(this);

				if (!$(this).hasClass('active')) {
					const $svgTooltip = $this.siblings('.tooltip-text');
					const $stage = $this.siblings('.stage');
					const svgTooltipText = $svgTooltip.html();
					const topSide = $this.siblings('g').offset().top - $('.production').offset().top;
					const $tooltip = $('.production__tooltip.js-prev');
					var leftSide = $this.parent('g').offset().left - $('.production').offset().left;
					const scrollTop = $(window).scrollTop();

					if ($svgTooltip.hasClass('tooltip-text--right')) {
						leftSide += $this.parent('g')[0].getBoundingClientRect().width;
						$tooltip.addClass('production__tooltip--right');
					} else {
						leftSide -= $tooltip.outerWidth();
						$tooltip.removeClass('production__tooltip--right');

						if ($svgTooltip.hasClass('tooltip-text--no-icon')) {
							$tooltip.addClass('production__tooltip--no-icon');
						} else {
							$tooltip.removeClass('production__tooltip--no-icon');
						}
					}

					$this.addClass('active');
					$stage.addClass('active');

					$('.production__tooltip.js-active')
						.removeClass('js-active')
						.addClass('js-prev');
					$tooltip
						.css({
							top: topSide,
							left: leftSide
						})
						.html(svgTooltipText)
						.velocity('stop', true)
						.velocity('fadeIn', 200)
						.addClass('js-active')
						.removeClass('js-prev');
				}
			})
			.on('mouseout', function (event) {
				const $this = $(this);

				if ($(this).hasClass('active')) {
					hideTooltip();
				}
			});
	}
});



// WEBPACK FOOTER //
// ./temp/components/production/index.js